import "./successModal.css";
import React from "react";
import { IoClose } from "react-icons/io5";
import { SuccessIcon } from "../../../assets";

function SuccessModal({ mode, title, message, onClose, handleCreateEvent }) {
	return (
		<>
			<div className="event_success_container">
				<div className="event_success_header">
					<h1>{title}</h1>
					<IoClose className="event_success_close_icon" onClick={onClose} />
				</div>

				<div className="event_success_body">
					<div className="event_success_icon">
						<img src={SuccessIcon} alt="Success Icon" />
					</div>

					<p className="event_success_message">{message}</p>

					<div className="event_modal_buttons">
						{mode === "fromCreate" ? (
							<button
								className="create_new_event_button"
								onClick={handleCreateEvent}
							>
								Create New
							</button>
						) : null}
						<button className="event_success_close_button" onClick={onClose}>
							Close
						</button>
					</div>
				</div>
			</div>
		</>
	);
}

export default SuccessModal;
